export default __webpack_public_path__ + "static/media/shu.5e934420.png";